// Frontend constants that match the backend shared types
export const GameEvents = {
  // Player events
  PLAYER_JOIN: 'player:join',
  PLAYER_LEAVE: 'player:leave',
  PLAYER_UPDATE: 'player:update',
  PLAYERS_REQUEST: 'players:request',
  PLAYERS_UPDATE: 'players:update',
  
  // Room events
  ROOM_CREATE: 'room:create',
  ROOM_JOIN: 'room:join',
  ROOM_LEAVE: 'room:leave',
  ROOM_CREATED: 'room:created',
  ROOM_JOINED: 'room:joined',
  ROOMS_REQUEST: 'rooms:request',
  ROOMS_UPDATE: 'rooms:update',
  
  // Garage events
  GARAGE_JOIN: 'garage:join',
  GARAGE_LEAVE: 'garage:leave',
  GARAGE_READY: 'garage:ready',
  GARAGE_UNREADY: 'garage:unready',
  GARAGE_START_GAME: 'garage:start_game',
  GARAGE_PLAYERS_UPDATE: 'garage:players_update',
  
  // Game events
  GAME_START: 'game:start',
  GAME_ACTION: 'game:action',
  PROJECTILE_FIRE: 'projectile:fire',
  DAMAGE_DEAL: 'damage:deal',
  PLAYER_DEAD: 'player:dead',
  
  // 3D Game events (simplified) - match backend exactly
  ADD_PLAYER: 'addPlayer',
  PLAYER_UPDATE_3D: 'playerUpdate',
  PLAYER_DISCONNECTED: 'playerDisconnected',
  FIRE_PROJECTILE: 'fireProjectile',
  DEAL_DAMAGE: 'dealDamage',
  PLAYER_DEAD_3D: 'playerDead',
  REQUEST_PLAYERS: 'requestPlayers',
  CONNECTED_PLAYERS: 'connectedPlayers',
  UPDATE_NAME: 'updateName',
  
  // Chat events
  CHAT_MESSAGE: 'chat:message',
  
  // Debug events
  DEBUG_JOIN: 'debug:join',
  DEBUG_INIT: 'debug:init',
  SOCKETS_UPDATE: 'sockets:update',
  SOCKET_LOG: 'socket:log'
} as const;

// Available tank skins - only those with loaded textures
export const TANK_SKINS = {
  T90A: 'T90A'
  // Removed T90B, T90C as their textures are not loaded to save texture units
} as const;

export type GameEventKey = keyof typeof GameEvents;

